import colors from './colors';

const highchartsTheme = {
  colors: colors.series,
  chart: {
    backgroundColor: colors.card,
    style: { fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' },
    plotBorderColor: colors.cardBorder,
  },
  title: { style: { color: colors.text, fontSize: '14px', fontWeight: '600' } },
  subtitle: { style: { color: colors.textMuted } },
  xAxis: {
    gridLineColor: colors.cardBorder,
    lineColor: colors.cardBorder,
    tickColor: colors.cardBorder,
    labels: { style: { color: colors.textMuted, fontSize: '11px' } },
    title: { style: { color: colors.textMuted } },
  },
  yAxis: {
    gridLineColor: colors.cardBorder,
    lineColor: colors.cardBorder,
    tickColor: colors.cardBorder,
    labels: { style: { color: colors.textMuted, fontSize: '11px' } },
    title: { style: { color: colors.textMuted } },
  },
  tooltip: {
    backgroundColor: '#1a1a3e',
    borderColor: colors.accent,
    style: { color: colors.text },
  },
  legend: {
    itemStyle: { color: colors.textMuted },
    itemHoverStyle: { color: colors.text },
  },
  credits: { enabled: false },
  plotOptions: {
    series: {
      animation: false,
    },
    line: { marker: { enabled: false } },
    spline: { marker: { enabled: false } },
  },
  time: { useUTC: false },
  exporting: {
    buttons: {
      contextButton: {
        symbolStroke: colors.textMuted,
        theme: { fill: colors.card },
      },
    },
  },
};

export default highchartsTheme;
